<mat-card class="mecs-errors-dialog">
  <mat-card-header>
    <mat-card-title>{{ data.title || 'Overridden MECS Errors' }}</mat-card-title>
  </mat-card-header>

  <mat-card-content>
    <div class="table-container" *ngIf="parsedErrors.length > 0">
      <table mat-table [dataSource]="parsedErrors" class="mecs-errors-table">

        <!-- Error Message Column -->
        <ng-container matColumnDef="errorMessage">
          <th mat-header-cell *matHeaderCellDef>Error Message</th>
          <td mat-cell *matCellDef="let error">{{ error.errorMessage }}</td>
        </ng-container>

        <!-- Cylinder Name Column -->
        <ng-container matColumnDef="cylinderName">
          <th mat-header-cell *matHeaderCellDef>Cylinder Name</th>
          <td mat-cell *matCellDef="let error">{{ error.cylinderName }}</td>
        </ng-container>

        <!-- Keyway Column -->
        <ng-container matColumnDef="keyway">
          <th mat-header-cell *matHeaderCellDef>Keyway</th>
          <td mat-cell *matCellDef="let error">{{ error.keyway }}</td>
        </ng-container>

        <!-- Shearline Column -->
        <ng-container matColumnDef="shearline">
          <th mat-header-cell *matHeaderCellDef>Shearline</th>
          <td mat-cell *matCellDef="let error">{{ error.shearline }}</td>
        </ng-container>

        <!-- Key Name Column -->
        <ng-container matColumnDef="keyName">
          <th mat-header-cell *matHeaderCellDef>Key Name</th>
          <td mat-cell *matCellDef="let error">{{ error.keyName }}</td>
        </ng-container>

        <!-- KeySection Column -->
        <ng-container matColumnDef="keySection">
          <th mat-header-cell *matHeaderCellDef>KeySection</th>
          <td mat-cell *matCellDef="let error">{{ error.keySection }}</td>
        </ng-container>

        <!-- Bitting Column -->
        <ng-container matColumnDef="bitting">
          <th mat-header-cell *matHeaderCellDef>Bitting</th>
          <td mat-cell *matCellDef="let error">{{ error.bitting }}</td>
        </ng-container>

        <!-- Operated By Column -->
        <ng-container matColumnDef="operatedBy">
          <th mat-header-cell *matHeaderCellDef>Operated By</th>
          <td mat-cell *matCellDef="let error">
            <span class="operated-by-text"
                  [matTooltip]="error.operatedBy.length > 40 ? error.operatedBy : ''"
                  matTooltipPosition="above">{{ error.operatedBy }}</span>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>

    <div class="no-errors" *ngIf="parsedErrors.length === 0">
      <mat-icon>info</mat-icon>
      <span>No errors to display</span>
    </div>
  </mat-card-content>

  <mat-card-actions align="end" class="dialog-actions">
    <button mat-stroked-button class="close-button" (click)="close()">Close</button>
  </mat-card-actions>
</mat-card>
